module.exports = __webpack_public_path__ + "static/media/NE.48bb21d4.png";